import CityPageTemplate from "../city-template/CityPageTemplate";
import { sammamishConfig } from "./data";

export default function SammamishPage() {
  return <CityPageTemplate config={sammamishConfig} />;
}